import React from 'react';
import Modal from '@rd-web-markets/shared/dist/util/Modal';
import { useTranslation } from 'react-i18next';
import { SUPPORT_EMAIL_ADDRESS } from '@rd-web-markets/market/dist/constants';
import FaqsViewer from './FaqsViewer';
import { Col, Row } from 'react-bootstrap';
const HelpModal = _ref => {
  let {
    show,
    onHide
  } = _ref;
  const {
    t
  } = useTranslation();
  const modalBody = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", null, t('help_modal_text'), " ", SUPPORT_EMAIL_ADDRESS))), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("h3", {
      className: "text-center"
    }, t('faqs')), /*#__PURE__*/React.createElement(Row, {
      className: "justify-content-center flex-column"
    }, /*#__PURE__*/React.createElement(FaqsViewer, null)));
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    size: "lg",
    closeText: t('cancel'),
    title: t('help'),
    renderBody: () => modalBody(),
    onHide: onHide
  });
};
export default HelpModal;